function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const SortAlphaDescIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 4v12h2V4h2.5L4 .5.5 4H3zM14.5 7h-4c-.2 0-.4-.1-.4-.3s-.1-.4 0-.5L13.6 1h-3.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.2 0 .4.1.4.3s.1.4 0 .5L11.4 6h3.1c.3 0 .5.2.5.5s-.2.5-.5.5zM15.9 15.3l-3-6c0-.2-.2-.3-.4-.3s-.4.1-.4.3l-3 6c-.1.2 0 .5.2.7h.2c.2 0 .4-.1.4-.3l.9-1.7h3.4l.9 1.7c.1.2.4.3.7.2s.3-.4.1-.6zM11.3 13l1.2-2.4 1.2 2.4h-2.4z"
  }));
};
export default SortAlphaDescIcon;